import type { IMovementType, IMovementTypeGroup } from '@/entities/movement-type';
import { priorityMap } from '@/entities/movement-type/lib/consts.ts';
import type { TMovementType, TMovementTypeGroup } from '@/entities/movement-type/types';

export function sortMovementTypeLabels(types: string[], movementItems: (IMovementType | IMovementTypeGroup)[]): string {
  const uniqueTypes = Array.from(new Set(types));
  const labelMap: Record<string, string[]> = {};
  const groupMap: Record<string, string> = {};

  // Обрабатываем группы и отдельные типы
  movementItems.forEach((item) => {
    if ('types' in item) {
      item.types.forEach((type) => {
        groupMap[type as TMovementType | TMovementTypeGroup] = item.str;
      });
      labelMap[item.str] = item.label ? item.label.split(', ') : [];
    } else {
      labelMap[item.str] = item.label ? [item.label] : [];
    }
  });

  // Сортируем типы на основе приоритета и порядка в исходном массиве types
  const sortedLabels = uniqueTypes
    .filter((type) => labelMap[type] || groupMap[type])
    .sort((a, b) => {
      const aPriority = getPriority(groupMap[a] || a, movementItems);
      const bPriority = getPriority(groupMap[b] || b, movementItems);
      if (aPriority === bPriority) {
        return uniqueTypes.indexOf(a) - uniqueTypes.indexOf(b);
      }

      return aPriority - bPriority;
    })
    .flatMap((type) => labelMap[groupMap[type] || type] || []);

  // Преобразуем массив лейблов в строку с первой заглавной буквой
  return Array.from(new Set(sortedLabels))
    .map((label, index) => (index === 0 ? capitalizeFirstLetter(label) : label.toLowerCase()))
    .join(', ');
}

function getPriority(typeStr: string, movementItems: (IMovementType | IMovementTypeGroup)[]): number {
  const foundItem = movementItems.find((movementItem) => movementItem.str === typeStr);
  if (foundItem) {
    return priorityMap[foundItem.str as keyof typeof priorityMap] ?? Infinity;
  }

  return Infinity;
}

function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
